import PropTypes from 'prop-types';

import {
  FooterSimplified,
  SeoSnippetShape,
  AppBanner
} from '@spotahome/ui-library';

import { Mediator } from '@spotahome/soyuz-mediator';

import NoSSR from 'react-no-ssr';

import { useSeoCitiesContext } from '../context/SeoCitiesContext';

import { TOGGLE_MAP } from '../common/utils/channels';

import HeaderComponent from './Header';
import FiltersWrapper from './FiltersWrapper';

const SeoPageWrapper = ({
  loadModules,
  modules,
  deviceType,
  seoSnippet = {}
}) => {
  const isDesktop = deviceType === 'desktop';
  const { cityId } = useSeoCitiesContext();

  const handlerSwitcherClick = () => {
    Mediator.publish(TOGGLE_MAP);
  };

  return (
    <>
      <AppBanner source="seo" deviceType={deviceType} />
      <HeaderComponent
        deviceType={deviceType}
        onSwitcherClick={handlerSwitcherClick}
      />
      <NoSSR>
        <FiltersWrapper cityId={cityId} />
      </NoSSR>

      {modules &&
        loadModules(modules, seoSnippet, {
          isDesktop
        })}
      <FooterSimplified />
    </>
  );
};

SeoPageWrapper.propTypes = {
  modules: PropTypes.arrayOf(PropTypes.shape({})).isRequired,
  loadModules: PropTypes.func.isRequired,
  deviceType: PropTypes.oneOf(['smartphone', 'tablet', 'desktop']).isRequired,
  seoSnippet: PropTypes.shape(SeoSnippetShape)
};

export default SeoPageWrapper;
